import React from 'react';

import { styled } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import { VizType } from 'business/definitions';
import { useGetFilterCategories } from './hooks/getFilterCategories';
import GenericIndicatorFilter from './IndicatorFilter/GenericIndicatorFilter';
import MetricFilter from './IndicatorFilter/MetricFilter';
import TitleSearch from './IndicatorFilter/TitleSearch';
import { IndicatorFilterT } from '../helpers/types';

const StyFilterBar = styled('div')(({ theme }) => ({
    background: theme.palette.primary.background,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
}));

type FilterBarProps = {
    aggregationsFilter: IndicatorFilterT<Aggregation>[];
    integrationsFilter: IndicatorFilterT<string>[];
    metricsFilter: string[];
    search: string;
    setAggregationsFilter: (arg: IndicatorFilterT<Aggregation>[]) => void;
    setIntegrationsFilter: (arg: IndicatorFilterT<string>[]) => void;
    setMetricsFilter: (arg: string[]) => void;
    setSearch: (arg: string) => void;
    setVizTypesFilter: (arg: IndicatorFilterT<VizType>[]) => void;
    vizTypesFilter: IndicatorFilterT<VizType>[];
};

const FilterBar = ({
    aggregationsFilter,
    integrationsFilter,
    metricsFilter,
    search,
    setAggregationsFilter,
    setIntegrationsFilter,
    setMetricsFilter,
    setSearch,
    setVizTypesFilter,
    vizTypesFilter,
}: FilterBarProps): JSX.Element => {
    const {
        aggregationFilters: aggregationFiltersOptions,
        integrationFilters: integrationFilterOptions,
        vizTypeFilters: vizTypeFilterOptions,
    } = useGetFilterCategories();

    return (
        <StyFilterBar id="indicators-filter-bar">
            <Grid container spacing={2}>
                <Grid xs={2}>
                    <GenericIndicatorFilter
                        filter={vizTypesFilter}
                        filterType="chartType"
                        options={vizTypeFilterOptions}
                        setFilter={setVizTypesFilter}
                    />
                </Grid>
                <Grid xs={2}>
                    <GenericIndicatorFilter
                        filter={integrationsFilter}
                        filterType="connector"
                        options={integrationFilterOptions}
                        setFilter={setIntegrationsFilter}
                    />
                </Grid>
                <Grid xs={2}>
                    <MetricFilter
                        metricsFilter={metricsFilter}
                        setMetricsFilter={setMetricsFilter}
                    />
                </Grid>
                <Grid xs={2}>
                    <GenericIndicatorFilter
                        filter={aggregationsFilter}
                        filterType="aggregation"
                        options={aggregationFiltersOptions}
                        setFilter={setAggregationsFilter}
                    />
                </Grid>
                <Grid xs={4}>
                    <TitleSearch search={search} setSearch={setSearch} />
                </Grid>
            </Grid>
        </StyFilterBar>
    );
};

export default FilterBar;
